import { createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";

const initialState = {
  showDataPreview: false,
  showRecursiveForm: false,
  isEditRecursiveForm: false,
  showAddMore: true,
  editIndex: "",
  arrayName: "",
  minLength: "",
  maxLength: "",
  //To check if guardian information is needed
  associatedWf: false,
  //To save the minor details
  isMinor: false,
  //To disable the add member btn if age < 18
  isMinorDisabled: false,
  //Used when the minor is being edited
  isEditMinor: false,
  //To show that the date selected is for a minor (shows a note)
  isAssociatedWfDisabled: false,
  //To show a note when age > 18 is selected
  associatedWfAge: false,
  //Used when the minor being edited has guardian information added already
  isAssociated: false,
  //To disable the update btn when the minor age > 18 after editing
  isAssociatedDisabled: false,
  //rework
  associateRequired: false,/*  */
  currentFormType: "applicant",
  isKeyDuplicate: false,
  isSignerRecursion: false,
  //end of rework
  formFields: [],
  formButtons: [],
  recursiveActions: [],
  showData: [],
  saveData: [],
  recursiveFormData: {},
  deleteRecursiveDocument: [],
  signerParams: {},
  duplicates: {}, 
};

export const recursiveReducer = createSlice({
  name: "recursiveReducer",
  initialState,
  reducers: {
    setAssociateRequired: (state, action) => {
      state.associateRequired = action.payload;
    },
    setCurrentFormType: (state, action) => {
      state.currentFormType = action.payload;
    },
    setIsKeyDuplicate: (state, action) => {
      state.isKeyDuplicate = action.payload;
    },
    setIsSignerRecursion: (state, action) => {
      state.isSignerRecursion = action.payload;
    },
    setFormFields: (state, action) => {
      state.formFields = action.payload;
    },
    clearFormFields: (state) => {
      state.formFields = [];
    },
    setFormButtons: (state, action) => {
      state.formButtons = action.payload;
    },
    clearFormButtons: (state) => {
      state.formButtons = [];
    },
    setRecursiveActions: (state, action) => {
      state.recursiveActions = action.payload;
    },
    clearRecursiveActions: (state) => {
      state.recursiveActions = [];
    },
    setShowDataPreview: (state, action) => {
      state.showDataPreview = action.payload;
    },
    setShowRecursiveForm: (state, action) => {
      state.showRecursiveForm = action.payload;
    },

    setShowData: (state, action) => {
      state.showData = [...state.showData, action.payload];
    },
    setAddShowData: (state, action) => {
      state.showData = [
        ...state.showData,
        { [action.payload.key]: action.payload.value },
      ];
    },
    setDeleteShowData: (state, action) => {
      state.showData = [
        ...state.showData.filter((item, i) => i != action.payload),
      ];
    },
    setEditShowData: (state, action) => {
      state.showData.splice(action.payload.editIndex, 1, { ...action.payload.data });
    },
    clearShowData: (state) => {
      state.showData = [];
    },

    setAddSaveData: (state, action) => {
      state.saveData = [...state.saveData, action.payload];
    },
    setSaveData: (state, action) => {
      state.saveData = action.payload;
    },
    setEditSaveData: (state, action) => {
      state.saveData.splice(action.payload.editIndex, 1, { ...action.payload.data });
    },
    setDeleteSaveData: (state, action) => {
      state.saveData = [
        ...state.saveData.filter((item, i) => i != action.payload),
      ];
    },
    clearSaveData: (state, action) => {
      state.saveData = [];
    },

    setRecursiveFormData: (state, action) => {
      state.recursiveFormData = {
        ...state.recursiveFormData,
        [action.payload.key]: action.payload.value,
      };
    },
    clearRecursiveFormDataKey: (state, action) => {
      state.recursiveFormData = {
        ...state.recursiveFormData,
      };
      delete state.recursiveFormData[action.payload.key];
    },
    clearRecursiveFormData: (state) => {
      state.recursiveFormData = {};
      // state.recursiveFormData[state.arrayName]=true
    },

    setIsEditRecursiveForm: (state, action) => {
      state.isEditRecursiveForm = action.payload;
    },
    setEditIndex: (state, action) => {
      state.editIndex = action.payload;
    },

    setShowAddMore: (state, action) => {
      state.showAddMore = action.payload;
    },

    setArrayName: (state, action) => {
      state.arrayName = action.payload;
    },
    setMinLength: (state, action) => {
      state.minLength = action.payload;
    },
    setMaxLength: (state, action) => {
      state.maxLength = action.payload;
    },
    setIsMinor: (state, action) => {
      state.isMinor = action.payload;
    },
    setAssociatedWf: (state, action) => {
      state.associatedWf = action.payload;
    },
    setIsAssociatedWfDisabled: (state, action) => {
      state.isAssociatedWfDisabled = action.payload;
    },
    setIsMinorDisabled: (state, action) => {
      state.isMinorDisabled = action.payload;
    },
    setAssociatedWfAge: (state, action) => {
      state.associatedWfAge = action.payload;
    },
    setIsEditMinor: (state, action) => {
      state.isEditMinor = action.payload;
    },
    setIsAssociated: (state, action) => {
      state.isAssociated = action.payload;
    },
    setIsAssociatedDisabled: (state, action) => {
      state.isAssociatedDisabled = action.payload;
    },
    setdeleteRecursiveDocument: (state, action) => {
      state.deleteRecursiveDocument.push(action.payload.value)
    },
    cleardeleteRecursiveDocument: (state, action) => {
      state.deleteRecursiveDocument = []
    },
    setSignerParams: (state, action) => {
      if (action.payload.key) {
        state.signerParams = {
          ...state.signerParams,
          [action.payload.key]: action.payload.value,
        };
      }
    },
    clearSignerParams: (state, action) => {
      state.signerParams = {}
    },
    setDuplicateStatus: (state, action) => {
      const { field, isDuplicate } = action.payload;
      state.duplicates[field] = isDuplicate;
    },
    clearDuplicateStatus: (state, action) => {
      const { field } = action.payload;
      delete state.duplicates[field];
    }
   
  },
});

// Action creators are generated for each case reducer function
export const {
  setFormFields,
  clearFormFields,
  setShowDataPreview,
  setShowData,
  setAddShowData,
  setSaveData,
  setAddSaveData,
  clearSaveData,
  clearShowData,
  setRecursiveFormData,
  clearRecursiveFormData,
  setDeleteSaveData,
  setDeleteShowData,
  setFormButtons,
  clearFormButtons,
  setShowRecursiveForm,
  clearRecursiveFormDataKey,
  setIsEditRecursiveForm,
  setEditIndex,
  setEditSaveData,
  setEditShowData,
  setRecursiveActions,
  clearRecursiveActions,
  setShowAddMore,
  setArrayName,
  setMinLength,
  setMaxLength,
  setAssociatedWf,
  setIsMinor,
  setIsMinorDisabled,
  setIsAssociatedWfDisabled,
  setAssociatedWfAge,
  setIsEditMinor,
  setIsAssociated,
  setIsAssociatedDisabled,
  setAssociateRequired,
  setCurrentFormType,
  setIsKeyDuplicate,
  setIsSignerRecursion,
  setdeleteRecursiveDocument,
  cleardeleteRecursiveDocument,
  setSignerParams,
  clearSignerParams,
  setDuplicateStatus,
  clearDuplicateStatus
} = recursiveReducer.actions;

export default recursiveReducer.reducer;
